export {
  EXPERIMENTS,
  isExperimentName,
  isRegisteredExperiment,
  type ExperimentName,
} from './registry';
export { useTreatment, type TreatmentResult } from './useTreatment';
export { useTreatments } from './useTreatments';
export { processExperimentParamsFromURL } from './queryParams';
export {
  getOverride,
  getAllOverrides,
  setOverride,
  clearOverride,
  clearAllOverrides,
} from './overrides';
export { getExperimentOverride, getExperimentOverrides } from './server';
export { isControlTreatment, type HpTreatmentDto } from './hotpadsExperimentClient';
export { experimentKeys } from './queryKeys';

// Server-only helpers (`prefetchTreatment`, `prefetchTreatments`) are exported
// from `./prefetch` directly to keep this barrel client-safe. Server
// Components should `import { prefetchTreatment } from '@/src/lib/experiments/prefetch'`.
